import { isClient, isProfessional } from '@/utils/resources/auth/authResource';
import { pagePath } from '@/utils/router/pagePath';
/**
 * 相談するボタンのリンクを取得する
 */
export const getConsultationLink = (auth) => {
    // クライアントの場合
    if (isClient(auth)) {
        return pagePath.hotline.client.createInput();
    }
    // コンサルタントの場合
    if (isProfessional(auth)) {
        return pagePath.hotline.professional.list();
    }
    // それ以外の場合（ゲストユーザー）
    return pagePath.login();
};
